import { Avatar, Divider, Menu, MenuItem } from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import message from "Assets/message.svg";
import logo_super from 'Assets/trade-india-logo.svg';
import Notifications from "Shared/Notifications";
;

const Header = () => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const navigate = useNavigate();
    const role = localStorage.getItem("role");
    const email = localStorage.getItem("email");
    const superuserId = localStorage.getItem("is_superuser");
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const handleLogout = () => {

        localStorage.clear();

        window.location.reload()
    };
    const [data, setData] = useState(false);

    // const Logo = () => {
    //     axios
    //         .get(
    //             `https://mstore.bhaaraterp.com/api/admin/multi-vendor-my-profile/`,

    //             {
    //                 headers: {
    //                     Token: localStorage.getItem("Token"),
    //                 },
    //             }
    //         )
    //         .then((response) => {
    //             setData(response?.data?.data?.profile_data[0]);
    //         })
    //         .catch((error) => { });
    // };
    // useEffect(() => {
    //     Logo();
    // }, []);

    return (
        <>
            <div className="flex flex-row h-16 shadow bg-white border-white sticky top-0">
                <div
                    className="grid grid-cols-[300px_1fr] bg-white border-b-0 border-r z-50 sticky border-gray-300 "
                >
                    <div className="m-5">
                        {
                            superuserId === "true" ?
                                <img
                                    src={logo_super}
                                    alt="logo_super"
                                    className="cursor-pointer h-16 p-1"
                                />
                                :
                                <img
                                    src={data?.store_image}
                                    alt="brandlogo"
                                    className="cursor-pointer h-16 p-1"
                                />
                        }
                    </div>
                </div>

                <div
                    className="flex items-center w-full justify-between text-zinc-700 bg-white"
                >
                    <div className="ml-7">
                        {/* <Search className="!border-none" /> */}
                    </div>

                    <div className="flex items-center justify-center cursor-pointer rounded-md px-3">
                        <div
                            className="flex items-center justify-center !my-2 cursor-pointer rounded-full px-3"
                            style={{
                                background: "linear-gradient(90deg, #BFEBFF,#F4E9FF)",
                            }}
                        >
                            <div className="flex gap-5 mr-10">
                                {/*  */}
                                <img src={message} alt="" className="!text-green-500" />
                                {/* <div
                  className="w-12 p-1 px-2 flex justify-between rounded-full"
                  style={{
                    background: "linear-gradient(135deg, #F261B7, #D05DEA)",
                  }}
                >
                  <IoMdNotifications className="!text-white" />
                  <span className="text-white text-[12px]">15</span>
                </div> */}
                                <Notifications />
                            </div>
                            {/* <div><PiDotsNineBold/></div> */}
                            {superuserId === "true" ? (
                                <Avatar
                                    alt="S"
                                    src="broken.jpg"
                                    className=" !bg-gray-600 p-2"
                                />
                            ) : (
                                <Avatar
                                    alt="A"
                                    src="broken.jpg"
                                    className="!my-2"
                                    style={{
                                        background: "linear-gradient(180deg, #A1A1DA, #949DED)",
                                    }}
                                />
                            )}

                            <div className="px-2 py-1 text-zinc-700" onClick={handleClick}>
                                {/* <h1 className="font-semibold !text-black">Dashboard</h1> */}
                                <h1 className="text-xs mb-1">
                                    {role}
                                    <br />
                                    {email}
                                </h1>
                            </div>

                            <Menu
                                anchorEl={anchorEl}
                                open={open}
                                onClose={handleClose}
                                className="!absolute !top-3 !right-40 !shadow-sm"
                                disableScrollLock
                                elevation={10}
                            >
                                <MenuItem
                                    className="hover:!rounded !mx-1"
                                    onClick={() => navigate("/dashboard/profile")}
                                >
                                    Profile
                                </MenuItem>
                                <MenuItem className="hover:!rounded !mx-1">
                                    Account Setting
                                </MenuItem>
                                <Divider />
                                <MenuItem
                                    className="hover:!rounded !mx-1"
                                    onClick={handleLogout}
                                >
                                    Logout
                                </MenuItem>
                            </Menu>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Header;
